import styled from "styled-components";

export const Title = styled.h1`
  font-size: ${({ theme }) => theme.fontSize.xxl};
  margin-bottom: -20px;
  color: ${({ theme }) => theme.colors.dark};
  text-align: center;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
`;
